import { gql } from 'apollo-angular';

import { ACCOUNT_PROFILE_FRAGMENT } from 'graphql/fragments/account-profile';
import { BRANCH_BASE_FRAGMENT } from 'graphql/fragments/branch-base';

export const ACCOUNT_BASE_FRAGMENT = gql`
  fragment AccountBaseFragment on Account {
    ...AccountProfileFragment
    branches {
      ...BranchBaseFragment
    }
    status
    rfpShow
  }
  ${ACCOUNT_PROFILE_FRAGMENT}
  ${BRANCH_BASE_FRAGMENT}
`;
